module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/banner_repertorio.8c01971f.png";